export default {
  'colors': ['#0266C8', '#F90101', '#F2B50F', '#00933B'],
  'chart': {
    'style': {
      'fontFamily': 'Arial',
      'color': '#444444'
    }
  },
  'xAxis': {
    'gridLineWidth': 1,
    'gridLineColor': '#F3F3F3',
    'lineColor': '#F3F3F3',
    'minorGridLineColor': '#F3F3F3',
    'tickColor': '#F3F3F3',
    'tickWidth': 1
  },
  'yAxis': {
    'gridLineColor': '#F3F3F3',
    'lineColor': '#F3F3F3',
    'minorGridLineColor': '#F3F3F3',
    'tickColor': '#F3F3F3',
    'tickWidth': 1
  },
  'legendBackgroundColor': 'rgba(0, 0, 0, 0.5)',
  'background2': '#505053',
  'dataLabelsColor': '#B0B0B3',
  'textColor': '#C0C0C0',
  'contrastTextColor': '#F0F0F3',
  'maskColor': 'rgba(255,255,255,0.3)'
}



// WEBPACK FOOTER //
// ./src/components/report/themes/google.js